(function () {
    if (window.Shopify && window.Shopify.designMode) return;
  var cookieName = 'bacchanalia-age-verified';
  var cleanup = null;

  function hasConfirmation() {
    try {
      return document.cookie.split(';').some(function (cookie) {
        return cookie.trim() === cookieName + '=1';
      });
    } catch (error) {
      return false;
    }
  }

  function setConfirmation(maxAge) {
    try {
      document.cookie = cookieName + '=' + (maxAge ? '1' : '') +
        '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (error) {}
  }

  function initAgeVerification() {
    if (cleanup) cleanup();
    var popup = document.querySelector('.age-verification-popup');
    if (!popup || hasConfirmation()) return;

    var btnYes = popup.querySelector('[data-btn-yes]');
    var btnNo = popup.querySelector('[data-btn-no]');
    var previousFocus = document.activeElement;
    var wasLocked = document.body.classList.contains('overflow-hidden');

    function focusableElements() {
      return Array.from(popup.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ));
    }

    function focusGuard(event) {
      if (!popup.contains(event.target)) {
        event.stopImmediatePropagation();
        var elements = focusableElements();
        if (elements.length) elements[0].focus();
      }
    }

    function keyGuard(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (event.key !== 'Tab') return;

      var elements = focusableElements();
      if (!elements.length) return;

      var first = elements[0];
      var last = elements[elements.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function accept() {
      setConfirmation(30 * 24 * 60 * 60);
      cleanup();
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }

    function decline() {
      setConfirmation(0);
      window.location.replace('https://drinkwise.org.au/');
    }

    cleanup = function () {
      popup.classList.remove('active');
      popup.style.visibility = 'hidden';
      if (!wasLocked) document.body.classList.remove('overflow-hidden');
      document.removeEventListener('focusin', focusGuard, true);
      popup.removeEventListener('keydown', keyGuard, true);
      if (btnYes) btnYes.removeEventListener('click', accept);
      if (btnNo) btnNo.removeEventListener('click', decline);
      cleanup = null;
    };

    popup.style.visibility = 'visible';
    popup.classList.add('active');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('focusin', focusGuard, true);
    popup.addEventListener('keydown', keyGuard, true);
    if (btnYes) btnYes.addEventListener('click', accept);
    if (btnNo) btnNo.addEventListener('click', decline);
    if (btnYes) btnYes.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeVerification);
  } else {
    initAgeVerification();
  }

  document.addEventListener('shopify:section:load', initAgeVerification);
  document.addEventListener('shopify:section:unload', function (event) {
    if (cleanup && event.target.querySelector('.age-verification-popup')) {
      cleanup();
    }
  });
})();